<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters"  size="mini">
				<el-form-item label="项目名称">
					<el-select v-model="filters.projectId" placeholder="请选择项目名称" filterable  @change="getDevices">
						<el-option
							v-for="item in projects"
							:label="item.name"
							:value="item.projectId" :key="item.projectId">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="设备编码" v-if="type==0">
					<el-select v-model="filters.mn"  multiple collapse-tags  @change="getMns" filterable reserve-keyword :filter-method="filterChangeMN" style="width:300px" >
                        <el-option value="全选" label="全选"></el-option>
                        <el-option value="取消全选" label="取消全选"></el-option>
						<el-option
							v-for="item in devicesFil"
							:label="item.mnCode"
							:value="item.mnCode" :key="item.mnCode">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="点位名称">
					<el-select v-model="filters.mn"  multiple collapse-tags  @change="getMns" filterable reserve-keyword :filter-method="filterChangeName" style="width:300px" >
                        <el-option value="全选" label="全选"></el-option>
                        <el-option value="取消全选" label="取消全选"></el-option>
						<el-option
							v-for="item in devicesFil"
							:label="item.name"
							:value="item.mnCode" :key="item.mnCode">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="时间范围">
					<el-date-picker
                        v-model="filters.time" type="datetimerange" unlink-panels :picker-options="pickerOptions" 
                        range-separator="至"  start-placeholder="开始日期"  end-placeholder="结束日期"  align="right">
                    </el-date-picker>
                </el-form-item>
				<el-form-item>
					<form-query-button  @select-type="getEventList" >  </form-query-button>
					<export-button  @select-type="exportEventList" >  </export-button>
				</el-form-item>
			</el-form>
		</el-col>

		<el-table :data="dataList" border  highlight-current-row v-loading="listLoading" style="width: 100%;" 
            :height="formHeight"  size="small" >
			<el-table-column type="index" label="序号"  ></el-table-column>
			<el-table-column  prop="deviceName"  label="点位名称" ></el-table-column>
			<el-table-column  prop="mn" label="设备编码"  v-if="type==0"></el-table-column>
			
			<el-table-column prop="time" label="时间" ></el-table-column>
			<el-table-column prop="diff" label="偏差(dB)"  >
				<template slot-scope="scope">
					<span v-if="scope.row.diff<=0.5&&scope.row.diff>=-0.5" style="color:green">{{scope.row.diff}}</span>
					<span v-else style="color:red">{{scope.row.diff}}</span>
				</template>
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-pagination layout="total, sizes, prev, pager, next, jumper" @current-change="handleCurrentChange" :page-size="pageSize" :total="total" style="float:right;" :page-sizes="[ 10, 20, 30,40,50]"   @size-change="handleSizeChange" :current-page.sync="page">
			</el-pagination>
		</el-col>

	</section>
</template>

<script>
	import { getProjects,getDevicesByProjectId,getEventList} from '../../api/api';
	import {formatDate,in_array} from '../../../static/fun.js';

	import FormQueryButton from '../../components/myButton/FormQueryButton.vue'
	import ExportButton from '../../components/myButton/ExportButton.vue'

	export default {
	components: { FormQueryButton,ExportButton },
		data() {
			return {
				pickerOptions: {
                    shortcuts: [{
                        text: '最近一天',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
                        picker.$emit('pick', [start, end]);
                        }
                    },{
                        text: '最近一周',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近三个月',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                        }
                    }]
                },
				filters: {
					projectId:"",
					mn:"",
					time:[],
					eventType:"0"
				},
				total: 0,
				page:1,
				pageSize:10,
				listLoading: false,
				dataList:[],
				firstFlag:true,
				devices:[],
				devicesFil:[],
				deviceMap:new Map(),
				projects:[],
				formHeight:0,

				type:sessionStorage.getItem("type"),
			}
			
		},
		methods: {
			handleCurrentChange(val) {
				this.page=val;
				this.getEventList();
			},
			handleSizeChange(val){
				this.pageSize=val;
				this.getEventList();
			},
			//查询项目信息
			getProjects() {
				this.listLoading = true;
				getProjects().then((res) => {
					this.projects = res.data.data;
					this.listLoading = false;
			        if(this.projects.length>0){
						this.filters.projectId=this.projects[0].projectId;
						this.getDevices();
					}
				});
			},
			//获取设备列表
			getDevices() {
                  let para = {
					projectId: this.filters.projectId
                };
				getDevicesByProjectId(para).then((res) => {
					this.devices = res.data.data;
					this.devicesFil=this.devices;
					this.filters.mn=[];
					
					if(this.devices.length>0){
						for (let index = 0; index < this.devices.length; index++) {
							const element = this.devices[index];
							this.deviceMap.set(element.mnCode,element.name);
						}
					}

					
					if(this.firstFlag){
						this.firstFlag=false;
						this.getEventList();
					}
				});
            },
			filterChangeMN(v){
				var copy=Object.assign([],this.devices);
                if(!in_array({mnCode:'全选'},copy)){
                    copy.push( {mnCode:'全选'});
                }
                 if(!in_array({mnCode:'取消全选'},copy)){
                    copy.push( {mnCode:'取消全选'});
				}
				var dev=v.split(",");

                //对绑定数据赋值
                this.devicesFil = copy.filter((item) => {
                    //如果直接包含输入值直接返回true
					if (item.mnCode=="全选"||item.mnCode=="取消全选") return true;
					else if(dev.toString()==""){
						return true;
					}
					else{
						var flag=false;
						dev.forEach(element => {
							if (item.mnCode.indexOf(element) !== -1&&element!="") {
								flag=true;
							}
						});
						return flag;
					}
                })
			},
			filterChangeName(v){
				var copy=Object.assign([],this.devices);
                if(!in_array({mnCode:'全选'},copy)){
                    copy.push( {mnCode:'全选'});
                }
                 if(!in_array({mnCode:'取消全选'},copy)){
                    copy.push( {mnCode:'取消全选'});
				}
				var dev=v.split(",");

                //对绑定数据赋值
                this.devicesFil = copy.filter((item) => {
                    //如果直接包含输入值直接返回true
					if (item.mnCode=="全选"||item.mnCode=="取消全选") return true;
					else if(dev.toString()==""){
						return true;
					}
					else{
						var flag=false;
						dev.forEach(element => {
							if (item.name.indexOf(element) !== -1&&element!="") {
								flag=true;
							}
						});
						return flag;
					}
                })
			},
			//获取选中设备
            getMns(){
                // this.getDeviceName();
                if(this.filters.mn.toString()==""){
                    return;
                }
                else if(in_array('取消全选',this.filters.mn)){
                    this.filters.mn=[];
                    return;
                }
                else if(in_array('全选',this.filters.mn)){
                    this.filters.mn=[];
                    this.devicesFil.forEach(element => {
                        this.filters.mn.push(element.mnCode);
                    });
                }
            },
			//获取历史数据信息
			getEventList(){
				var starttime='';
                var endtime='';
                if(this.filters.time!=null&&this.filters.time.length>0){
                    starttime=formatDate(this.filters.time[0]);
					endtime=formatDate(this.filters.time[1]);
                }
				let para = {
					eventType:this.filters.eventType,
					projectId:this.filters.projectId,
					page: this.page,
					pageSize:this.pageSize,
					mn: this.filters.mn.toString(),
					startDate: starttime,
                    endDate: endtime
				};
				this.listLoading = true;
				getEventList(para).then((res) => {
					this.listLoading = false;
					this.total = res.data.data.total;
					this.dataList = res.data.data.data;
					for(var i=0;i<this.dataList.length;i++){
						var data=this.dataList[i];
						data.deviceName=this.deviceMap.get(data.mn);
					}
				});
			},
			exportEventList(){
				var starttime='';
                var endtime='';
                if(this.filters.time!=null&&this.filters.time.length>0){
                    starttime=formatDate(this.filters.time[0]);
					endtime=formatDate(this.filters.time[1]);
                }
				let para = {
					eventType:this.filters.eventType,
					projectId:this.filters.projectId,
					page: 1,
					pageSize:999999,
					mn: this.filters.mn.toString(),
					startDate: starttime,
                    endDate: endtime
				};
				getEventList(para).then((res) => {
					this.listLoading = false;
					var dataList = res.data.data.data;
					for(var i=0;i<dataList.length;i++){
						var data=dataList[i];
						data.deviceName=this.deviceMap.get(data.mn);
					}
					//导出
					this.exportData(dataList);
				});
			},
			exportData(dataList){
				const { export_json_to_excel } = require('vendor/Export2Excel');
				const tHeader =  ['点位名称', '设备编码','时间','偏差' ];
				const filterVal = ['deviceName', 'mn', 'time','diff'];  

				var data=[];
				var sheetName=[];
				data.push(this.formatJson(filterVal, dataList));
				sheetName.push('Sheet1');

				export_json_to_excel(tHeader, data, '设备自检报告',sheetName);
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            }, 
			SetHeight:function(){
				var hgt=document.getElementsByClassName('content-container')[0].clientHeight;
				var titleHgt=document.getElementsByClassName('tags-view-wrapper')[0].clientHeight;
				var toolbarHgt=document.getElementsByClassName('toolbar')[0].clientHeight+document.getElementsByClassName('toolbar')[1].clientHeight;
				this.formHeight=hgt-titleHgt-toolbarHgt-120;
			},
			setTime(){
				var end = new Date();
				var start = new Date();
                start.setTime(start.setDate(start.getDate()-1));
				this.filters.time= [formatDate(start), formatDate(end)];
				this.getProjects();
			}
		},
		mounted() {
			var _this=this;
			var timer=null;
			clearInterval(timer);
			timer =setInterval(function(){
				if(_this.formHeight ==0){
					_this.SetHeight();
				}else{
					clearInterval(timer);
				}
			},10)
			
			this.setTime();
		},
	}

</script>

<style>
	.cell{
		text-align: center;
	}
	.timeFar{
		float: right;
		margin-right: 20px;
	}
	.el-form{
		overflow: hidden;
	}
	.el-col-1{
        text-align: center;
    }
</style>


// WEBPACK FOOTER //
// SelfInspectionRecords.vue?b35b0208